import { PopoverButton, PopoverPanel } from "@headlessui/react";
import { useEffect } from "react";

import Block from "./Block.jsx";
import { Row } from "react-bootstrap";
import PopoverPanelWithBlockFilter from "./PopoverPanelWithBlockFilter.jsx";

const CATEGORIES_WITH_FILTER = ["Templates"];

const moveCanvasBehindPopover = () => {
  document.querySelector(".main-content") && document.querySelector(".main-content").style.setProperty("z-index", "-1");
};

const moveCanvasToFront = () => {
  document.querySelector(".main-content") && document.querySelector(".main-content").style.removeProperty("z-index");
};

const CustomPopover = ({ open, close, category, categoryBlocks, dragStart, dragStop }) => {
  useEffect(() => {
    if (open) moveCanvasBehindPopover();
    return () => {
      moveCanvasToFront();
    };
  }, [open]);

  return (
    <>
      <PopoverButton className={`category ${open ? "opened" : ""}`}>{category}</PopoverButton>
      <PopoverPanel className="block-container shadow">
        {CATEGORIES_WITH_FILTER.includes(category) ? (
          <PopoverPanelWithBlockFilter
            categoryBlocks={categoryBlocks}
            close={close}
            dragStart={dragStart}
            dragStop={dragStop}
          />
        ) : (
          <Row>
            {categoryBlocks.map((block) => (
              <Block
                key={block.getId()}
                block={block}
                close={close}
                dragStart={dragStart}
                dragStop={dragStop}
              />
            ))}
          </Row>
        )}
      </PopoverPanel>
    </>
  );
};

export default CustomPopover;
